import {
  AppToastsController,
  MemberInvitesController,
} from '@wix/social-groups-common/dist/src/controllers';
import { IWidgetControllerConfig } from '@wix/native-components-infra/dist/src/types/types';
import { ExperimentsBag } from '@wix/wix-experiments';
import { Controller } from '../common/Controller';
import GroupsController from './GroupsController';
import { GroupsPageProps } from '../../components/App/types';

export class GroupsPageController extends Controller<GroupsPageProps> {
  protected readonly groupsController: GroupsController;

  constructor(
    controllerConfig: IWidgetControllerConfig,
    experiments: ExperimentsBag = {},
  ) {
    super(controllerConfig, experiments);
    this.groupsController = new GroupsController(controllerConfig, experiments);
    this.controllers.push(
      this.groupsController,
      new AppToastsController(controllerConfig),
      new MemberInvitesController(controllerConfig),
    );
  }
}
